import {Record, type RecordOf} from 'immutable';
import {createFieldPath} from '@packages/systems/dynamo/utils/ParamFieldPathUtils';
import {type OperatorId} from '@packages/systems/dynamo/utils/DynQueryUtils';

export type DynQueryParamShape = {
  fieldPath: string;
  fieldType: string;
  operator: OperatorId;
  value: string | number | null;
  value2: string | number | null;
  value3: string | number | null;
  open: boolean;
  mint: boolean;
};

export type DynQueryParamType = RecordOf<DynQueryParamShape>;

// @ts-expect-error - TS2322 - Type 'Factory<{ fieldPath: string; operator: ""; value: string; value2: string; value3: string; open: false; mint: false; }>' is not assignable to type 'Factory<DynQueryParamShape>'.
export const DynQueryParam: Record.Factory<DynQueryParamShape> = Record(
  {
    fieldPath: createFieldPath(''),
    operator: '',
    value: '',
    value2: '',
    value3: '',

    // transient
    open: false,
    mint: false,
  },
  'DynQueryParam'
);
